import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';

class AdminTBD extends Component {

    render() {
        return (
            <Card>
                <p>This administrative area is under construction.</p>
            </Card>
        )
    }
}

export default AdminTBD;


// WEBPACK FOOTER //
// ./src/components/AdminHome/AdminTBD.js